import { useLazyQuery } from "@apollo/client";
import { QUERY_ALBARAN } from "../graphql/queries";

export const useWaybill = () => {
  const [getAlbaran] = useLazyQuery(QUERY_ALBARAN);
  return {
    getAlbaran,
  };
};
